import styled from "styled-components";

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;
